import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const brevo = defineConnector({
  identifier: "brevo",
  name: "Brevo",
  tagLine: "Marketing and transactional email platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.brevo\\.com/.*",
  auth: (app) => headerAuth([{ name: "api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Brevo](https://www.brevo.com/), go to **Settings → SMTP & API → API Keys** and generate a new key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Brevo API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.brevo.com/v3/account",
  },
});
